import axios, { type AxiosStatic } from 'axios';
import type { App, ObjectPlugin } from 'vue';
import {
  dynatraceResponseErrorInterceptor,
  dynatraceResponseInterceptor,
  metadataRequestInterceptor,
  sessionManagerRequestErrorInterceptor,
  sessionManagerRequestInterceptor,
  sessionManagerResponseErrorInterceptor,
  sessionManagerResponseInterceptor,
  setCorrelationId,
} from './axiosInterceptors';

export const axiosPlugin: ObjectPlugin = {
  install(_: App, _axios: AxiosStatic | null) {
    setCorrelationId();
    const _a = _axios ?? axios;
    // ? use session manager to handle passing tokens
    _a.interceptors.request.use(
      sessionManagerRequestInterceptor,
      sessionManagerRequestErrorInterceptor
    );
    // ? use session manager to handle 401 requests by refreshing tokens
    _a.interceptors.response.use(
      sessionManagerResponseInterceptor,
      sessionManagerResponseErrorInterceptor
    );
    // ? use dynatrrase to tag response and errors
    _a.interceptors.response.use(dynatraceResponseInterceptor, dynatraceResponseErrorInterceptor);
    // ? setup some monitoring metadata and misc tasks
    _a.interceptors.request.use(metadataRequestInterceptor);
  },
};
